module.exports = __webpack_public_path__ + "img/CB[1]-WF-1.fc61c1fd.gif";